import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { openReview } from "../../../api/knowledgeData/knowledgeDataApi";
import type { AcceptanceStep, CurationState } from "../../../api/knowledgeData/knowledgeDataDecoders";
import ErrorNotice from "../../../errors/ErrorNotice";
import { useSubmission } from "../../../shared/state/useSubmission";
import { appPaths } from "../../../shared/routing/appPaths";
import { useWorkspace } from "../../../shell/workspace";

/**
 * "Open its review" for a result that waits (F84 §9): its acceptance step in its Thread,
 * where a curator accepts or rejects it (ADR-0026 slice 3a). A result no step was asked for
 * yet gets one when a curator opens it; the server refuses anyone else. Nothing is decided
 * here.
 */
export default function OpenReview({ source, state, review }: { source: string; state: CurationState; review: AcceptanceStep | null }) {
  const { t } = useTranslation();
  const workspace = useWorkspace();
  const submission = useSubmission();
  if (state !== "proposed") return null;
  if (review !== null) {
    return <Link className="app-link text-xs" to={appPaths.thread(review.threadId)}>{t("data.review.open")}</Link>;
  }
  const open = () => {
    submission.submit(async () => {
      const step = await openReview(source);
      workspace.open(appPaths.thread(step.threadId));
    });
  };
  return (
    <>
      <button type="button" className="app-link text-xs" disabled={submission.state.status === "submitting"} onClick={open}>
        {t("data.review.open")}
      </button>
      {submission.state.status === "failed" ? <ErrorNotice error={submission.state.error} compact={true} /> : null}
    </>
  );
}
